<!--<template>-->
<!--  <div >-->
<!--&lt;!&ndash;    <Header />&ndash;&gt;-->
<!--&lt;!&ndash;    <div class="container d-flex justify-content-center">&ndash;&gt;-->
<!--&lt;!&ndash;      <UserLoginForm />&ndash;&gt;-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->
<!--    -->
<!--  </div>-->
<!--</template>-->

<!--<script>-->
<!--import Header from "@/components/layout/utils/Header";-->
<!--import UserLoginForm from "@/components/UserLoginForm";-->

<!--export default {-->
<!--  name: "userLogin",-->
<!--  components: { Header, UserLoginForm },-->
<!--};-->
<!--</script>-->

<!--<style scoped>-->
<!--.main-page {-->
<!--  background-image: url("../assets/img/background.png");-->
<!--}-->
<!--</style>-->

<template>
  <div class="login-page">
    <div class="background-image"></div>
    <div class="container d-flex justify-content-center">
      <UserLoginForm />
    </div>
  </div>
</template>

<script>
import Header from "@/components/layout/utils/Header";
import UserLoginForm from "@/components/UserLoginForm";

export default {
  name: "userLogin",
  components: { Header, UserLoginForm },
};
</script>

<style scoped>
.login-page {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.background-image {
  background-color: #f5f5f5;
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.login-form-container {
  background-color: rgba(255, 255, 255, 0.8);
  padding: 20px;
  border-radius: 8px;
  width: 300px;
  text-align: center;
}

h2 {
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}

input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

button {
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}
</style>

